import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';

import { ISlimScrollOptions } from 'ng2-slimscroll';
import { MemberService } from './../member.service';
import { MessageEvent, SignInEvent, OpenFrameEvent, LoaderEvent, HiddenFooter } from './../../shared/message.event';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { Member } from './../member';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
    selector: 'app-member-detail',
    templateUrl: './member-detail.component.html',
    styleUrls: ['./member-detail.component.css'],
    providers: [MemberService, MessageEvent, SignInEvent, OpenFrameEvent, LoaderEvent, HiddenFooter]
})
export class MemberDetailComponent implements OnInit {
    private _router;
    private shouldSlide: boolean = false;
    private popUpMessage: string;
    private popUpTitle: string;
    private validate;
    private vendor;
    private windowHeight = window.innerHeight;
    private topNav = 56;
    private midNav = 45;
    private footer = 35;
    private container = 50;
    private height: any;
    private divHeight = 30;
    private pagebutton = 10;
    private memberViewDetail: Member;
    private viewDetail = true;
    private previousMemberObj: any;
    private scrollOptions: ISlimScrollOptions;
    private facilityList = [];
    private disableMemberObj;
    private isDeactivateButton: boolean = false;
    private clubName: string;
    private joinDate: any;
    private isJoinDate: boolean = false;
    private errorMessage: string;
    private utilityFunctions = new UtilityFunctions();

    constructor(private router: Router, private memberService: MemberService, private appService: AppService,
        private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private hiddenFooter: HiddenFooter,
        private signInEvent: SignInEvent, private loaderEvent: LoaderEvent) {
        this._router = router;
        this.popUpMessage = '';
        this.memberViewDetail = {
            'userId': '',
            'vendorId': '',
            'emailId': '',
            'contactNumber': '',
            'membershipId': '',
            'firstName': '',
            'lastName': '',
            'addressLine1': '',
            'addressLine2': ''
        };
        this.validate = {
            'emailId': '',
            'contactNumber': '',
            'membershipId': '',
            'firstName': '',
            'lastName': '',
            'flag': false
        };
        this.disableMemberObj = {
            'userIds': [],
            'facilityId': '',
            'facilityName': '',
            'vendorId': '',
            'startTime': '',
            'endTime': '',
            'reason': '',
            'clubName': ''
        };
        this.scrollOptions = {
            barBackground: "#343a40", barOpacity: "0.6", position: "right",
            barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px", gridBackground: "#adb5bd", gridOpacity: "1", gridWidth: "4", gridBorderRadius: "10", gridMargin: "1px 2px"
        };
        this.errorMessage = '';
        this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight + this.pagebutton)) + 'px';
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        this.clubName = this.vendor.clubName;
    }

    ngOnInit() {
        this.showDetail()
        this.appService.getFacilityList(this.vendor._id).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.facilityList = result.facilityData;
            }
        }).catch((err) => {
            this.popUpMessage = err;
            this.loaderEvent.fire(true);
        });
        this.registerTypeBroadcast();
        this.emitOpenFrameEvent();
        this.emitTypeBroadcast();
    }

    /**
     * while menu slide left to right as well as we shift header, footer and body too by broadcaster  
     */
    registerTypeBroadcast() {
        this.messageEvent.on()
            .subscribe(message => {
                this.shouldSlide = message;
            });
    }
    /**
     * Show specific member details  
     */
    showDetail() {
        this.loaderEvent.fire(false);
        let memberEmailId = JSON.parse(atob(localStorage.getItem('memberEmailId')));
        let memberDetail = {
            vendorId: this.vendor._id,
            emailId: memberEmailId
        };
        this.appService.getMemberDetail(memberDetail).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.memberViewDetail = result.userDetails;
                this.isDeactivateButton = result.userDetails.isBlackListed;
                this.previousMemberObj = JSON.parse(JSON.stringify(result.userDetails));
                this.joinDate = moment(this.memberViewDetail['signedUpOn']).format('DD/MM/YYYY');
                this.isJoinDate = this.joinDate === 'Invalid date';
            } else {
                this._router.navigate(['/member']);
            }
            this.loaderEvent.fire(true);
        }).catch((err) => {
            this.loaderEvent.fire(true);
        });
    }
    /**
     * Get member details
     * 
     * 
     * @memberof MemberDetailComponent
     */
    fetchMemberDetails() {
        this.memberViewDetail = this.appService.showMemberDetail();
        if (this.memberViewDetail) {
            this.isDeactivateButton = this.memberViewDetail['isBlackListed'];
            this.previousMemberObj = JSON.parse(JSON.stringify(this.memberViewDetail));
            this.joinDate = this.memberViewDetail['signedUpOn'];
            this.isJoinDate = this.joinDate === 'Invalid date';
        } else {
            this._router.navigate(['/member']);
        }
    }
    emitTypeBroadcast() {
        let isShow = {
            privacypolicy: true,
            support: false,
            footer: 'block'
        };
        this.signInEvent.fire('block');
        this.hiddenFooter.fire(isShow);
    }

    emitOpenFrameEvent() {
        this.openFrameEvent.fire(false);
    }

    /**
     * Go to home screen  
     */
    homeScreen() {
        this.utilityFunctions.homeScreen(this);
    }

    /**
     * Make details editable
     */
    changeMode() {
        this.viewDetail = false;
    }
    /**
     * Show popup for delete member
     */
    makeDelete(userId, popUpObj) {
        this.popUpMessage = CONSTANT_MESSAGES.DELETE_MEMBER;
        popUpObj.showChildModal();
    }
    /**
     * Soft member details
     */
    confirmDelete(event, userId) {
        if (event) {
            let obj = {
                vendorId: this.vendor._id,
                userId: userId,
                emailId: this.memberViewDetail.emailId,
                contactNumber: this.memberViewDetail.contactNumber
            };
            this.memberService.deleteMember(obj).then((result: any) => {
                if (result.status === 'SUCCESS') {
                    this._router.navigate(['/']);
                } else {
                }
            });
        }
    }
    /**
     * Show popup to resend unique code to members email id
     */
    resendMail(emailId, popUpObj) {
        if (emailId) {
            this.popUpMessage = CONSTANT_MESSAGES.RESEND_CODE_MEMBER;
            popUpObj.showChildModal();
        }
    }

    /**
     * Resend unique code to members email id
     */
    confirmResendMail(event, obj: any, popUpObj) {
        let memberObj = {
            emailId: obj.emailId,
            contactNumber: obj.contactNumber,
            membershipId: obj.membershipId,
            firstName: obj.firstName,
            lastName: obj.lastName,
            type: obj.type,
            uniqueCode: obj.uniqueCode,
            userId: obj.userId
        };
        if (event && obj) {
            let obj = {
                vendorId: this.vendor._id,
                members: [memberObj],
                isWaitForCallback: false,
                clubName: this.vendor.clubName
            };
            this.memberService.resendMail(obj).then((result: any) => {
                if (result.status === 'SUCCESS') {
                } else {
                }
                this.popUpMessage = result.message;
                popUpObj.showChildModal();
            });
        }
    }

    /**
     * Show popup to deactivate member
     */
    makeDisable(userId, popUpObj) {
        this.popUpMessage = CONSTANT_MESSAGES.DEACTIVATE_MEMBER;
        this.popUpTitle = 'Deactivate Member';
        popUpObj.showChildModal(this.popUpTitle, this.popUpMessage);
    }
    /**
     * Make deactivate member
     */
    confirmDeactivate(event, userId, popUpObj) {
        if (event) {
            let startDate: Date = event.startDate.setHours(0, 0, 0, 0);
            let endDate;
            if (event.endDate) {
                endDate = event.endDate ? event.endDate.setHours(24, 0, 0, 0) : null;
                endDate = new Date(endDate).toISOString();
            }
            let obj = {
                vendorId: this.vendor._id,
                userIds: userId ? [userId] : [],
                startTime: this.utilityFunctions.maketimeZoneOfsetDate(startDate, true),
                endTime: endDate ? this.utilityFunctions.maketimeZoneOfsetDate(endDate, true) : null,
                reason: event.reason
            };
            this.memberService.markDeactiveToMember(obj).then((result: any) => {
                if (result.status === 'SUCCESS') {
                    this._router.navigate(['/']);
                } else {
                    this.popUpMessage = result.message;
                    popUpObj.showChildModal();
                }
            });
        }
    }
    /**
     * Show popup to activate member
     */
    makeActivate(userId, popUpObj) {
        this.popUpMessage = CONSTANT_MESSAGES.ACTIVATE_MEMBER;
        popUpObj.showChildModal();
    }

    /**
     * Make activate member
     */
    confirmActivate(event, userId, popUpObj) {
        if (event) {
            let obj = {
                vendorId: this.vendor._id,
                userIds: [userId]
            };
            this.memberService.markActiveToMember(obj).then((result: any) => {
                if (result.status === 'SUCCESS') {
                    this._router.navigate(['/']);
                } else {
                    this.popUpMessage = result.message;
                    popUpObj.showChildModal();
                }
            });
        }
    }
    /**
        * Validate all member details fields while update
        */
    validationForMandatoryFields(validatePara) {
        try {
            let validateFlag = true;
            switch (validatePara) {
                case 'membershipId':
                    if (!this.memberViewDetail.membershipId) {
                        this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    } else {
                        this.validate.membershipId = '';
                    }
                    break;
                case 'emailId':
                    if (!this.memberViewDetail.emailId) {
                        this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    } else {
                        this.validate.emailId = '';
                    }
                    break;
                case 'contactNumber':
                    if (!this.memberViewDetail.contactNumber) {
                        this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    } else {
                        this.validate.contactNumber = '';
                    }
                    break;
                case 'firstName':
                    if (!this.memberViewDetail.firstName) {
                        this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    } else {
                        this.validate.firstName = '';
                    }
                    break;
                case 'lastName':
                    if (!this.memberViewDetail.lastName) {
                        this.validate.lastName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    } else {
                        this.validate.lastName = '';
                    }
                    break;
                case '':
                    validateFlag = this.validateMandatoryFields();
                    break;
            }
            return validateFlag;
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Validate all member detail fields
     * 
     * @returns 
     * 
     * @memberof MemberDetailComponent
     */
    validateMandatoryFields() {
        this.validate.flag = true;
        if (!(this.memberViewDetail.membershipId + '').trim()) {
            this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.membershipId = '';
        }
        if (!this.utilityFunctions.validateEmail(this.memberViewDetail.emailId)) {
            this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.emailId = '';
        }
        if (!(this.memberViewDetail.contactNumber + '').trim()) {
            this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.contactNumber = '';
        }
        if (!(this.memberViewDetail.firstName + '').trim()) {
            this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.firstName = '';
        }
        if (!(this.memberViewDetail.lastName + '').trim()) {
            this.validate.lastName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.lastName = '';
        }
        return this.validate.flag;
    }
    /**
    * Update member details
    */
    updateMember(messagePopUp) {
        if (this.validateMandatoryFields()) {
            let member = {
                vendorId: this.vendor._id,
                membershipId: this.memberViewDetail.membershipId.trim(),
                emailId: this.memberViewDetail.emailId.trim(),
                firstName: this.memberViewDetail.firstName.trim(),
                lastName: this.memberViewDetail.lastName.trim(),
                contactNumber: this.memberViewDetail.contactNumber,
                oldEmailId: this.previousMemberObj.emailId
            };
            this.memberService.updateMember(member).then((result: any) => {
                if (result.status === 'SUCCESS') {
                    this._router.navigate(['/']);
                } else {
                    this.errorMessage = result.message;
                    messagePopUp.showChildModal();
                }
            });
        }
    }
    /**
     * Disable member
     */
    disableMember(disableObj: any, popUpObj: any) {
        this.disableMemberObj.facilityName = disableObj.facility.name;
        // this.disableMemberObj.duration = disableObj.days * 24;
        this.disableMemberObj.facilityId = disableObj.facility._id;
        this.disableMemberObj.vendorId = this.vendor._id;
        this.disableMemberObj.userIds = this.memberViewDetail.userId ? [this.memberViewDetail.userId] : [];
        this.disableMemberObj.startTime = this.utilityFunctions.maketimeZoneOfsetDate(disableObj.startTime, true);
        this.disableMemberObj.endTime = this.utilityFunctions.maketimeZoneOfsetDate(disableObj.endTime, true);
        this.disableMemberObj.reason = disableObj.reason;
        this.disableMemberObj.clubName = this.vendor.clubName;
        this.loaderEvent.fire(false);
        this.memberService.disableMemberForSpecificFacility(this.disableMemberObj).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.popUpMessage = result.message;
            } else {
                this.popUpMessage = result.message;
            }
            popUpObj.showChildModal();
            this.loaderEvent.fire(true);
        }).catch((err) => {
            this.popUpMessage = err;
            this.loaderEvent.fire(true);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/member/member-detail/member-detail.component.ts